import fetchMock from 'fetch-mock';

fetchMock.config.fallbackToNetwork = true;

export { fetchMock };

export const cancelSpeech = async () => {
  window.speechSynthesis.cancel();
  await timeout(250);
};

export const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export function selectKey(event, index, ids, focusedElement, setState, arrows) {
  let i;
  if (event.key === arrows[0]) {
    if (index === ids.length - 1) {
      if (focusedElement !== ids[index]) {
        const newID = focusedElement ? ids.indexOf(focusedElement) : 0;
        i = newID + 1;
      } else {
        i = 0;
      }
      setState(i);
      document.getElementById(ids[i]).focus();
    } else {
      if (focusedElement !== ids[index]) {
        const newID = ids.indexOf(focusedElement)
          ? ids.indexOf(focusedElement)
          : 0;
        if (newID === ids.length - 1) {
          i = 0;
          setState(i);
          document.getElementById(ids[i]).focus();
        } else {
          i = newID;
          i++;
          setState(i);
          document.getElementById(ids[i]).focus();
        }
      } else {
        i = index;
        i++;
        setState(i);
        document.getElementById(ids[i]).focus();
      }
    }
  }

  if (event.key === arrows[1]) {
    if (index === 0) {
      if (focusedElement !== ids[index]) {
        const newID = focusedElement ? ids.indexOf(focusedElement) : ids.length;
        i = newID - 1;
      } else {
        i = ids.length - 1;
      }
      setState(ids.length - 1);
      document.getElementById(ids[i]).focus();
    } else {
      if (focusedElement !== ids[index]) {
        const newID = focusedElement ? ids.indexOf(focusedElement) : ids.length;
        if (newID === 0) {
          i = ids.length - 1;
          setState(i);
          document.getElementById(ids[i]).focus();
        } else {
          i = newID;
          i--;
          setState(i);
          document.getElementById(ids[i]).focus();
        }
      } else {
        i = index;
        i--;
        setState(i);
        document.getElementById(ids[i]).focus();
      }
    }
  }
}
